import { Flex, Group, Title } from "@mantine/core";
import { createFileRoute, useSearch } from "@tanstack/react-router";

import type { RouterContextType } from "@/api/permissions/permissions.api";
import { MODULE_KEYS_MAP } from "@/api/permissions/permissions.types";
import { CloseOutQueue } from "@/components/features/CloseOut/CloseOutQueue";
import { useBreadcrumb } from "@/hooks/useBreadcrumb";
import { useRequestScope } from "@/hooks/useRequestScope";
import { tableSearchSchema } from "@/hooks/useTableUrlPersistence";
import { authGuardWithPermissions } from "@/utils/authGuard";
import { getRouteIcon } from "@/utils/getRouteIconComponent";

import styles from "./close-out.module.scss";

export const Route = createFileRoute("/_authenticated/close-out/")({
  component: CloseOut,
  validateSearch: tableSearchSchema.parse,
  beforeLoad: async (args) => {
    await authGuardWithPermissions({
      context: args.context as RouterContextType,
      location: args.location as { pathname: string },
    });
  },
});

function CloseOut() {
  const searchParams = useSearch({ from: "/_authenticated/close-out/" });
  const requestScope = useRequestScope();

  useBreadcrumb(
    [
      {
        title: "Close Out",
        href: "/close-out",
        icon: getRouteIcon(MODULE_KEYS_MAP.closeOut),
      },
    ],
    { listView: "List View" },
  );

  return (
    <Flex direction="column" className={styles.container}>
      <Group justify="space-between" align="center" className={styles.header}>
        <Title order={3} className={styles.title}>
          Workorder Close Out
        </Title>
      </Group>

      <CloseOutQueue key={requestScope} searchParams={searchParams} />
    </Flex>
  );
}
